// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* TAG STATUS */\n/* VIEW */\n.status-template-container .status-list[data-v-3daa9051] {\n  list-style-type: none;\n  padding: 0;\n}\n.status-template-container .status-list li[data-v-3daa9051] {\n  margin-bottom: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
